import { Link, LinkProps } from 'react-router-dom';

export type RecordLinkProps = Omit<LinkProps, 'target' | 'rel'>;

export const RecordLink = ({ className = 'text-indigo', title = 'Open in new tab', ...props }: RecordLinkProps) => (
  <Link
    {...props}
    className={className}
    title={title}
    target="_blank"
    rel="noopener noreferrer"
  />
);
